export const licenseKey =
  'ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogImVlZTQ4NzUyLTU5ZmMtNGJmMy05MGMxLWZmOTgwMmJlOWFhNiIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjUxCn0=.W34RX+f5xJjsvicEn9XbHvcVE+4Cl7+aHmRgyDKx53ZHEWsmwL2s/3owDCx4miRfQ/EYTT+m/JRp9DJDF8QFGcuhbc43znoC3aZ2jXoVMq3AQLsauvN0NHw7I0ffrLwVvpiZhw==';
